import React, { useEffect, useState } from "react";

import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
  LinearProgress,
  Collapse,
  IconButton,
  TextField,
  Tooltip,
  Stack,
  Grid,
  InputAdornment,
  Card,
  CardContent,
  Divider,
  TablePagination,
  Checkbox,
  FormControl,
  FormControlLabel,
  NativeSelect,
  Chip,
} from "@mui/material";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  Edit,
  Search,
  ReceiptLong,
  CalendarMonth,
  Person,
  CurrencyRupee,
  Done,
  Close,
} from "@mui/icons-material";
import configServ from "../../services/config";
import PrintIcon from "@mui/icons-material/Print";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import CustomDateRangePicker from "../../Components/DatePicker/CustomDateRangePicker";
import pdfImage from "../../Components/Assets/images/pdf.jfif";
import excelImage from "../../Components/Assets/images/excel.png";
import DownloadChallanPdf from "../../Components/Download/DownloadChallanPdf ";
import { useSelector } from "react-redux";
import DownloadChallanExcel from "../../Components/Download/DownloadChallanExcel";
import DownloadVendorChallanExcel from "../../Components/Download/DownloadVendorChallanExcel";
import ChallanDispatchPopup from "./ChallanDispatchPopup";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { color } from "framer-motion";

// import withReactContent from "sweetalert2-react-content";
const ChallanTable = ({
  handleEditData,
  isChanged,
  handleCopyChallan,
  data,
  entityType = "customer",
}) => {
  const [challans, setChallans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openRow, setOpenRow] = useState(null);
  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchChallan, setSearchChallan] = useState("");
  const [page, setPage] = useState(0); // MUI Pagination is 0-based
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [total, setTotal] = useState(0);
  const [dateRange, setDateRange] = useState([null, null]);
  const defaultSessionYear = "2026-27";
  const [sessionYear, setSessionYear] = useState(defaultSessionYear);
  const [refresh, setRefresh] = useState(false);
  const [orderBy, setOrderBy] = useState("challan_no");
  const [order, setOrder] = useState("asc");

  const handleClearSearchCustomer = () => {
    setPage(0);
    setSearchCustomer("");
  };

  const handleClearSearchChallan = () => {
    setPage(0);
    setSearchChallan("");
  };

  const handleClearDateRange = () => {
    setPage(0);
    setDateRange([null, null]);
  };

  const handleClearSessionYear = () => {
    setPage(0);
    setSessionYear(defaultSessionYear);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setPage(0);
  };
  const { company_id, companyName, permissions, is_super, is_admin } = useSelector((state) => state.GlobalVariables);
  useEffect(() => {
    if (data) {
      handlePrint(data);
      console.log("print", data);
    }
  }, [data]);
  useEffect(() => {
    fetchChallans();
  }, [
    page,
    rowsPerPage,
    searchCustomer,
    searchChallan,
    isChanged,
    dateRange,
    refresh,
    sessionYear,
    orderBy,
    order,
  ]);

  useEffect(() => {
    setPage(0); // Reset to first page on filter change
    fetchChallans();
  }, [dateRange, refresh, sessionYear, orderBy, order]);

  const fetchChallans = async () => {
    try {
      setLoading(true);
      const params = {
        company_id: company_id,
        page: page + 1, // API usually expects 1-based index
        per_page: rowsPerPage,
        challan_no: searchChallan,
        session_year: sessionYear,
        start_date: dateRange[0]
          ? dayjs(dateRange[0]).format("YYYY-MM-DD")
          : "",
        end_date: dateRange[1] ? dayjs(dateRange[1]).format("YYYY-MM-DD") : "",
        sort_by: orderBy,
        sort_order: order,
      };

      if (entityType === "supplier") {
        params.supplier_name = searchCustomer;
      } else {
        params.customer_name = searchCustomer;
      }

      const res = entityType === "supplier"
        ? await configServ.getAllVendorChallans(params)
        : await configServ.getAllChallans(params);

      setChallans(res.data || []);
      setTotal(res.total || 0);
    } catch (error) {
      console.error("Error fetching challans", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePrint = async (data) => {
    setLoading(true);
    let customerEmail = null;
    let isEmailEnabled = false;

    if (entityType !== "supplier") {
      try {
        const emailRes = await configServ.getCustomerEmailByID({
          customer_id: data.customer_id || data.from_customer_id,
        });
        if (emailRes.status === 200 && emailRes.data) {
          customerEmail = emailRes.data;
          isEmailEnabled = true;
        }
      } catch (e) {
        console.error("Email fetch error", e);
      }
    }

    setLoading(false);

    // 2. Custom Styled Popup
    Swal.fire({
      title: "",
      showConfirmButton: false,
      showCloseButton: true,
      width: 450,
      html: `
      <div style="display: flex; border-bottom: 2px solid #eee; margin-bottom: 20px;">
        <div id="tab-email" style="flex: 1; padding: 10px; cursor: pointer; font-weight: bold; color: #1976d2; border-bottom: 3px solid #1976d2;">EMAIL</div>
        <div id="tab-print" style="flex: 1; padding: 10px; cursor: pointer; font-weight: bold; color: #666;">PRINT</div>
      </div>

      <div id="content-container" style="min-height: 200px; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 10px;">
        
        <div id="view-email" style="text-align: center; width: 100%;">
          <h3 style="color: #555; font-weight: 400; margin-bottom: 20px;">Save paper, send the job work via email!</h3>
          <button id="realEmailBtn" class="swal2-styled" 
            style="background-color: ${isEmailEnabled ? "#4caf50" : "#e0e0e0"}; color: ${isEmailEnabled ? "#fff" : "#999"}; padding: 10px 25px; display: flex; align-items: center; gap: 8px; margin: 0 auto; cursor: ${isEmailEnabled ? "pointer" : "not-allowed"}" 
            ${!isEmailEnabled ? "disabled" : ""}>
            <span class="material-icons" style="font-size: 18px;">mail</span> SEND EMAIL
          </button>
          ${
            !isEmailEnabled
              ? `
            <p style="color: #d32f2f; margin-top: 20px; font-size: 14px; font-weight: 500;">
              No email address found. Please update customer email to continue.
            </p>
          `
              : `<p style="color: #2e7d32; margin-top: 15px;">Send to: ${customerEmail}</p>`
          }
        </div>

        <div id="view-print" style="display: none; text-align: center; width: 100%;">
          <h3 style="color: #555; font-weight: 400; margin-bottom: 10px;">Select Print Settings</h3>
          <div style="margin-bottom: 20px;">
            <label style="display: block; margin-bottom: 8px; font-size: 14px; color: #666;">Number of Pages</label>
           <div id="print-pages" style="display: flex; justify-content: center; gap: 20px;">
  <label style="font-size: 14px; color: #666;">
    <input type="radio" name="print_page" value="1" checked />
    1 Page
  </label>

  <label style="font-size: 14px; color: #666;">
    <input type="radio" name="print_page" value="2" />
    2 Pages
  </label>

  <label style="font-size: 14px; color: #666;">
    <input type="radio" name="print_page" value="3" />
    3 Pages
  </label>
</div>
          </div>
          <button id="realPrintBtn" class="swal2-confirm swal2-styled" style="background-color: #1976d2; padding: 10px 30px;">
            DOWNLOAD PDF
          </button>
        </div>

      </div>
    `,
      didOpen: () => {
        const tEmail = document.getElementById("tab-email");
        const tPrint = document.getElementById("tab-print");
        const vEmail = document.getElementById("view-email");
        const vPrint = document.getElementById("view-print");

        // Tab Switching Logic
        tEmail.addEventListener("click", () => {
          tEmail.style.color = "#1976d2";
          tEmail.style.borderBottom = "3px solid #1976d2";
          tPrint.style.color = "#666";
          tPrint.style.borderBottom = "none";
          vEmail.style.display = "block";
          vPrint.style.display = "none";
        });

        tPrint.addEventListener("click", () => {
          tPrint.style.color = "#1976d2";
          tPrint.style.borderBottom = "3px solid #1976d2";
          tEmail.style.color = "#666";
          tEmail.style.borderBottom = "none";
          vPrint.style.display = "block";
          vEmail.style.display = "none";
        });

        // Email Action
        // Email Action inside Swal didOpen
        document
          .getElementById("realEmailBtn")
          .addEventListener("click", async () => {
            Swal.showLoading();
            try {
              const res = await configServ.sendEmailApiChallan({
                id: data.id,
                email: customerEmail,
              });

              if (res.status === 200) {
                Swal.fire(
                  "Sent!",
                  "Email has been sent to " + customerEmail,
                  "success",
                );
              } else {
                Swal.fire(
                  "Error",
                  res.message || "Failed to send email",
                  "error",
                );
              }
            } catch (err) {
              Swal.fire("Error", "Server connection failed", "error");
            }
          });

        // Print Action
        document
          .getElementById("realPrintBtn")
          .addEventListener("click", async () => {
            const selectedRadio = document.querySelector(
              'input[name="print_page"]:checked',
            );
            const pages = selectedRadio ? selectedRadio.value : 1;

            Swal.close();
            handleActualDownload(data.id, pages);
          });
      },
    });
  };

  // Separate function for download to keep code clean
  const handleActualDownload = async (id, pages) => {
    setLoading(true);
    try {
      const response = await configServ.PrintChallan_PDF_api({
        id,
        page: pages,
      });
      if (response.status === 200) {
        const linkSource = `data:application/pdf;base64,${response.pdf}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = response.file_name || "challan.pdf";
        downloadLink.click();
      } else {
        Swal.fire("Error", "Could not generate PDF", "error");
      }
    } catch (err) {
      Swal.fire("Error", "Server Error", "error");
    } finally {
      setLoading(false);
    }
  };

  // --- Sub-Component for Mobile Cards ---
  const MobileCard = ({ row }) => {
    const isExpanded = openRow === row.id;

    return (
      <Card key={row.id} variant="outlined" sx={{ borderRadius: 3, boxShadow: 1, overflow: 'hidden' }}>
        <CardContent sx={{ p: 2, backgroundColor: isExpanded ? '#F3F9FF' : '#fff' }}>
          <Stack spacing={1}>
            <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1D5FB1' }}>
                  Job Work No: {row.challan_no}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                  {entityType === 'supplier' ? 'Supplier' : 'Customer'}: {entityType === 'supplier' ? row.supplier?.contact_name : row.customer?.contact_name || 'N/A'}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                  Date: {row.challan_date ? new Date(row.challan_date).toLocaleDateString() : 'N/A'}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                  Amount: ₹{parseFloat(row.total_amount || 0).toFixed(2)}
                </Typography>
                {entityType === 'supplier' && (
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                    Purchase Bill: <Typography component="span" sx={{ color: row.purchase_bill_generated ? 'green' : 'warning.main', fontWeight: 700 }}>{row.purchase_bill_generated ? 'Generated' : 'Pending'}</Typography>
                  </Typography>
                )}
              </Box>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenRow(isExpanded ? null : row.id);
                }}
                size="small"
                sx={{ color: '#1976d2', transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}
              >
                <KeyboardArrowDown />
              </IconButton>
            </Stack>

            <Divider sx={{ my: 1 }} />

            <Stack direction="row" flexWrap="wrap" spacing={1}>
              {Boolean(is_super || is_admin || permissions?.includes(63)) && (
                <Tooltip title={row.purchase_bill_generated ? 'Edit disabled for generated bill' : 'Edit Job Work'}>
                  <span>
                    <IconButton
                      color="primary"
                      size="small"
                      disabled={row.purchase_bill_generated}
                      onClick={() => handleEditData(row)}
                    >
                      <Edit fontSize="small" />
                    </IconButton>
                  </span>
                </Tooltip>
              )}
              <Tooltip title="Copy Job Work">
                <IconButton color="primary" size="small" onClick={() => handleCopyChallan(row)}>
                  <ReceiptLong fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Print Job Work">
                <IconButton color="primary" size="small" onClick={() => handlePrint(row)}>
                  <PrintIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title={row.is_dispatch ? 'Already dispatched' : 'Dispatch Job Work'}>
                <span>
                  <IconButton
                    color="primary"
                    size="small"
                    onClick={() => handleDispatch(row)}
                    disabled={row.is_dispatch}
                  >
                    <LocalShippingIcon fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
            </Stack>

            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
              <Box sx={{ mt: 2, p: 2, backgroundColor: '#F9FAFB', borderRadius: 2 }}>
                {row.items?.length > 0 ? (
                  <Stack spacing={1}>
                    {row.items.map((item) => (
                      <Box key={item.id} sx={{ p: 1, borderRadius: 2, bgcolor: '#fff', border: '1px solid #E0E0E0' }}>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>
                          {item.itemname || 'N/A'}
                        </Typography>
                        <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 0.5 }}>
                          <Typography variant="caption">Qty: {item.qty || 0}</Typography>
                          <Typography variant="caption">Rate: ₹{item.rate || 0}</Typography>
                          <Typography variant="caption">Total: ₹{item.amount || 0}</Typography>
                        </Stack>
                      </Box>
                    ))}
                  </Stack>
                ) : (
                  <Typography variant="body2">No item details available</Typography>
                )}
              </Box>
            </Collapse>
          </Stack>
        </CardContent>
      </Card>
    );
  };
  const [companyLogo, setCompanyLogo] = useState("");
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const assignCompanyLogo = async () => {
    try {
      const result = await configServ.company_logo({ company_id: company_id });
      if (result && result.image) {
        // Assuming the result.image is already a base64 string
        setCompanyLogo(`data:image/png;base64,${result.image}`);
      } else {
        setCompanyLogo(null); // Set as null if no logo
      }
    } catch (e) {
      console.log(e);
      setCompanyLogo(null); // Handle error by clearing logo
    }
  };

  useEffect(() => {
    assignCompanyLogo();
  }, []);

  const handleDownloadPdf = () => {
    DownloadChallanPdf(challans, companyName, companyLogo, setOpenBackdrop);
  };

  const handleDownloadExcel = () => {
    if (entityType === "supplier") {
      DownloadVendorChallanExcel(challans, companyName, setOpenBackdrop);
    } else {
      DownloadChallanExcel(challans, companyName, setOpenBackdrop);
    }
  };
  const [openDispatch, setOpenDispatch] = useState(false);
  const [dispatchDetail, setDispatchDetail] = useState(null);
  const closeDispatchPopup = () => {
    setOpenDispatch(false);
    setRefresh(!refresh);
  };
  const openDispatchPopup = () => {
    setOpenDispatch(true);
  };

  const handleDispatch = (params) => {
    try {
      const data = params;
      setDispatchDetail(data);
      openDispatchPopup();
      // handleClose();
    } catch (e) {
      console.log(e);
    }
  };

  const handleUpdatePurchaseBill = async (challanId, isGenerated) => {
    if (!isGenerated) {
      // Directly uncheck without popup
      try {
        const response = await configServ.updateVendorChallanStatus(challanId, {
          purchase_bill_generated: false,
        });

        if (response.success) {
          setRefresh(!refresh);
          Swal.fire(
            "Success",
            "Purchase bill status updated successfully",
            "success"
          );
        } else {
          Swal.fire("Error", response.message || "Failed to update", "error");
        }
      } catch (error) {
        console.error("Error updating purchase bill:", error);
        Swal.fire("Error", "Failed to update purchase bill status", "error");
      }
      return;
    }

    // Show popup for generating purchase bill
    Swal.fire({
      title: "Is Purchase Bill Generated?",
      html: `
        <div style="text-align: left; display: flex; flex-direction: column; gap: 16px; width: 100%; box-sizing: border-box; overflow: hidden;">
          <div style="width: 100%; box-sizing: border-box;">
            <label for="purchase_bill_remarks" style="display: block; margin-bottom: 6px; font-weight: bold; font-size: 14px;">Purchase Bill Remarks:</label>
            <input id="purchase_bill_remarks" class="swal2-input" placeholder="Enter remarks" style="width: 100%; box-sizing: border-box; max-width: 100%;">
          </div>
          <div style="width: 100%; box-sizing: border-box;">
            <label for="purchase_bill_no" style="display: block; margin-bottom: 6px; font-weight: bold; font-size: 14px;">Purchase Bill No:</label>
            <input id="purchase_bill_no" class="swal2-input" placeholder="Enter bill number" style="width: 100%; box-sizing: border-box; max-width: 100%;">
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Generate",
      cancelButtonText: "Cancel",
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: () => {
        const remarks = document.getElementById('purchase_bill_remarks').value;
        const billNo = document.getElementById('purchase_bill_no').value;
        if (!remarks.trim()) {
          Swal.showValidationMessage('Remarks are required');
          return false;
        }
        if (!billNo.trim()) {
          Swal.showValidationMessage('Purchase Bill No is required');
          return false;
        }
        return { remarks, billNo };
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        const { remarks, billNo } = result.value;
        try {
          const response = await configServ.updateVendorChallanStatus(challanId, {
            purchase_bill_generated: true,
            purchase_bill_remarks: remarks,
            purchase_bill_no: billNo,
          });

          if (response.success) {
            setRefresh(!refresh);
            Swal.fire(
              "Success",
              "Purchase bill generated successfully",
              "success"
            );
          } else {
            Swal.fire("Error", response.message || "Failed to update", "error");
          }
        } catch (error) {
          console.error("Error updating purchase bill:", error);
          Swal.fire("Error", "Failed to update purchase bill status", "error");
        }
      }
    });
  };

  return (
    <>
      <ChallanDispatchPopup
        openDispatch={openDispatch}
        closeDispatchPopup={closeDispatchPopup}
        dispatchDetail={dispatchDetail}
        refresh={refresh}
      />
      <Box sx={{ width: "100%", p: { xs: 1, md: 3 } }}>
        {/* Header & Filters */}
          <Grid item xs={12} justifyContent={"flex-start"} spacing={2} mb={3}>
            <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>
              <ReceiptLong /> Total Job Work: {total}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={12} sm={4} md={4} lg={3} xl={3} xxl={3}>
                <TextField
                  label={entityType === "supplier" ? "Search Supplier" : "Search Customer"}
                  size="small"
                  fullWidth
                  value={searchCustomer}
                  onChange={(e) => {
                    setPage(0);
                    setSearchCustomer(e.target.value);
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search fontSize="small" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} lg={3} xl={3} xxl={3}>
                <TextField
                  label="Job Work No"
                  size="small"
                  fullWidth
                  value={searchChallan}
                  onChange={(e) => {
                    setPage(0);
                    setSearchChallan(e.target.value);
                  }}
                />
              </Grid>
              {/* Date Range Picker */}
              <Grid item xs={12} sm={4} md={4} lg={2} xl={2} xxl={2}>
                <FormControl size="small" fullWidth>
                  <NativeSelect
                    value={sessionYear}
                    width="100%"
                    onChange={(e) => {
                      setPage(0);
                      setSessionYear(e.target.value);
                    }}
                    inputProps={{ name: "sessionYear", id: "session-year-native" }}
                  >
                    <option value="2023-24">2023-24</option>
                    <option value="2024-25">2024-25</option>
                    <option value="2025-26">2025-26</option>
                    <option value="2026-27">2026-27</option>
                    <option value="2027-28">2027-28</option>
                  </NativeSelect>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={2} xl={2} xxl={2}>
                <CustomDateRangePicker value={dateRange} onChange={setDateRange} />
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={2} xl={2} xxl={2}>
                <Box sx={{ display: "flex", alignItems: "right", justifyContent: "flex-end", gap: 1 }}>
                  <Tooltip title="Download PDF">
                    <IconButton onClick={handleDownloadPdf}>
                      <img
                        src={pdfImage}
                        alt="pdf"
                        style={{ width: 28, height: 28 }}
                      />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Download Excel">
                    <IconButton onClick={handleDownloadExcel}>
                      <img
                        src={excelImage} // 👈 tumhara excel image path
                        alt="excel"
                        style={{ width: 28, height: 28 }}
                      />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          {(searchCustomer || searchChallan || dateRange[0] || dateRange[1] || sessionYear !== defaultSessionYear) && (
            <Box sx={{ mb: 2, p: 2, backgroundColor: "#f0f8ff", borderRadius: 1, border: "1px solid #4CB5F5" }}>
              <Typography variant="body2" sx={{ fontWeight: 600, color: "#1565c0", mb: 1 }}>
                Active Filters:
              </Typography>
              <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ '& > *': { minWidth: 0 } }}>
                {searchCustomer && (
                  <Chip
                    label={`${entityType === "supplier" ? "Supplier" : "Customer"}: ${searchCustomer}`}
                    onDelete={handleClearSearchCustomer}
                    deleteIcon={<Close fontSize="small" />}
                    sx={{ backgroundColor: "#ffffff" }}
                  />
                )}
                {searchChallan && (
                  <Chip
                    label={`Job Work No: ${searchChallan}`}
                    onDelete={handleClearSearchChallan}
                    deleteIcon={<Close fontSize="small" />}
                    sx={{ backgroundColor: "#ffffff" }}
                  />
                )}
                {(dateRange[0] || dateRange[1]) && (
                  <Chip
                    label={`Date: ${dateRange[0] ? new Date(dateRange[0]).toLocaleDateString() : "Any"} - ${dateRange[1] ? new Date(dateRange[1]).toLocaleDateString() : "Any"}`}
                    onDelete={handleClearDateRange}
                    deleteIcon={<Close fontSize="small" />}
                    sx={{ backgroundColor: "#ffffff" }}
                  />
                )}
                {sessionYear !== defaultSessionYear && (
                  <Chip
                    label={`Session: ${sessionYear}`}
                    onDelete={handleClearSessionYear}
                    deleteIcon={<Close fontSize="small" />}
                    sx={{ backgroundColor: "#ffffff" }}
                  />
                )}
              </Stack>
            </Box>
          )}

        {loading && <LinearProgress sx={{ mb: 2, borderRadius: 2 }} />}

        {/* DESKTOP TABLE VIEW */}
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <TableContainer
            component={Paper}
            sx={{ borderRadius: 2, boxShadow: 3 }}
          >
            <Table>
              <TableHead sx={{ bgcolor: "#1976d2" }}>
                <TableRow>
                  <TableCell width="50" />
                  <TableCell
                    component="th"
                    scope="col"
                    sx={{ color: "#fff", fontWeight: 600, cursor: "pointer" }}
                    sortDirection={orderBy === "challan_no" ? order : false}
                    onClick={() => handleRequestSort("challan_no")}
                  >
                    <TableSortLabel
                      active={orderBy === "challan_no"}
                      direction={orderBy === "challan_no" ? order : "asc"}
                      sx={{ color: "white !important", "& .MuiTableSortLabel-icon": { color: "white !important" } }}
                    >
                      Job Work No
                    </TableSortLabel>
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="col"
                    sx={{ color: "#fff", fontWeight: 600, cursor: "pointer" }}
                    sortDirection={orderBy === "supplier_name" ? order : false}
                    onClick={() => handleRequestSort("supplier_name")}
                  >
                    <TableSortLabel
                      active={orderBy === "supplier_name"}
                      direction={orderBy === "supplier_name" ? order : "asc"}
                      sx={{ color: "white !important", "& .MuiTableSortLabel-icon": { color: "white !important" } }}
                    >
                      Supplier Name
                    </TableSortLabel>
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="col"
                    sx={{ color: "#fff", fontWeight: 600, cursor: "pointer" }}
                    sortDirection={orderBy === "challan_date" ? order : false}
                    onClick={() => handleRequestSort("challan_date")}
                  >
                    <TableSortLabel
                      active={orderBy === "challan_date"}
                      direction={orderBy === "challan_date" ? order : "asc"}
                      sx={{ color: "white !important", "& .MuiTableSortLabel-icon": { color: "white !important" } }}
                    >
                      Job Work Date
                    </TableSortLabel>
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="col"
                    sx={{ color: "#fff", fontWeight: 600, cursor: "pointer" }}
                    sortDirection={orderBy === "total_amount" ? order : false}
                    onClick={() => handleRequestSort("total_amount")}
                  >
                    <TableSortLabel
                      active={orderBy === "total_amount"}
                      direction={orderBy === "total_amount" ? order : "asc"}
                      sx={{ color: "white !important", "& .MuiTableSortLabel-icon": { color: "white !important" } }}
                    >
                      Amount
                    </TableSortLabel>
                  </TableCell>
                  {entityType === "supplier" && (
                    <TableCell
                      sx={{ color: "#fff", fontWeight: 600 }}
                      align="center"
                    >
                      Bill Done
                    </TableCell>
                  )}
                  <TableCell
                    sx={{ color: "#fff", fontWeight: 600 }}
                    align="center"
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {challans.map((row) => (
                  <React.Fragment key={row.id}>
                    <TableRow hover>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() =>
                            setOpenRow(openRow === row.id ? null : row.id)
                          }
                        >
                          {openRow === row.id ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )}
                        </IconButton>
                      </TableCell>
                      <TableCell fontWeight="500">{row.challan_no}</TableCell>
                      <TableCell>{
                        entityType === "supplier"
                          ? row.supplier?.contact_name
                          : row.customer?.contact_name
                      }</TableCell>
                      <TableCell>
                        {new Date(row.challan_date).toLocaleDateString()}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>
                        ₹{row.total_amount}
                      </TableCell>
                      {entityType === "supplier" && (
                        <TableCell align="center">
                          {row.purchase_bill_generated ? (
                            <Done color="success" fontSize="medium" />
                          ) : (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={false}
                                  onChange={(e) => handleUpdatePurchaseBill(row.id, e.target.checked)}
                                  size="small"
                                />
                              }
                              label=""
                            />
                          )}
                        </TableCell>
                      )}
                      <TableCell align="center">
                        {Boolean(
                          is_super || is_admin || permissions?.includes(63),
                        ) && (
                          <Tooltip title={row.purchase_bill_generated ? 'Edit disabled for bill generated record' : 'Edit Job Work'}>
                          <IconButton
                            color="primary"
                            disabled={row.purchase_bill_generated}
                            onClick={() => handleEditData(row)}
                            label="Edit Job Work"
                          >
                            <Edit />
                          </IconButton>
                          </Tooltip>
                        )}
                        <Tooltip title='Copy Job Work'>
                        <IconButton
                          color="primary"
                          disabled={row.purchase_bill_generated}
                          onClick={() => handleCopyChallan(row)}
                          label="Copy Job Work"
                        >
                          <ReceiptLong />
                        </IconButton>
                        </Tooltip>
                        <Tooltip title='Dispatch Job Work'>
                        <IconButton
                          color="primary"
                          onClick={() => handleDispatch(row)}
                          disabled={row.is_dispatch}
                        >
                          <LocalShippingIcon />
                        </IconButton>
                        </Tooltip>
                        <Tooltip title='Print Job Work'>
                        <IconButton
                          color="primary"
                          onClick={() => handlePrint(row)}
                        >
                          <PrintIcon />
                        </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ py: 0 }} colSpan={7}>
                        <Collapse in={openRow === row.id} unmountOnExit>
                          <Box
                            m={2}
                            p={2}
                            sx={{ bgcolor: "#fafafa", borderRadius: 1 }}
                          >
                            <Table size="small" sx={{ borderRadius: 2, boxShadow: 3 }}>
                              <TableHead sx={{ bgcolor: "#1976d2", color: "#fff", fontWeight: 600 }}>
                                <TableRow sx={{ color: "#fff", fontWeight: 600 }}>
                                  <TableCell>Item</TableCell>
                                  <TableCell align="right">Qty</TableCell>
                                  <TableCell align="right">Rate</TableCell>
                                  <TableCell align="right">Total</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {row.items?.map((item) => (
                                  <TableRow key={item.id}>
                                    <TableCell>{item.itemname}</TableCell>
                                    <TableCell align="right">
                                      {item.qty}
                                    </TableCell>
                                    <TableCell align="right">
                                      ₹{item.rate}
                                    </TableCell>
                                    <TableCell align="right">
                                      ₹{item.amount}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* MOBILE CARD VIEW */}
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          {challans.map((row) => (
            <MobileCard key={row.id} row={row} />
          ))}
        </Box>

        {/* COMMON PAGINATION */}
        <TablePagination
          component="div"
          count={total}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
          sx={{ mt: 2 }}
        />
      </Box>
    </>
  );
};

export default ChallanTable;
